import { render, staticRenderFns } from "./SelecionarVendedorRelat.vue?vue&type=template&id=3104ff12&"
import script from "./SelecionarVendedorRelat.vue?vue&type=script&lang=js&"
export * from "./SelecionarVendedorRelat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports